let mainClaimSection = document.getElementById('main_claim_section');
if (Boolean(mainClaimSection)) {
let claim_form_exists = mainClaimSection.querySelector(".sample_claim_form");
let claimSpinner = mainClaimSection.querySelector(".gcr-form-wu-spinner");
let errorContainer = mainClaimSection.querySelector(".main-error-block");
let captchaMainContainer =  mainClaimSection.querySelector("#main_captcha_container");
let disclaimerCheckContainer =  mainClaimSection.querySelector("#disclaimerCheckContainer");
let disclaimerCheck = document.getElementById('disclaimer_check');
let errorMsg = "";
let current_hostname = window.location.host;
window.sessionValue = "";
window.catchaResponse = "";
let show_captcha_feature = null;
const header ={"Content-type": "application/json"};

    const loadDefaultValues = () => {
        show_captcha_feature = mainClaimSection.querySelector('#show_captcha_feature').getAttribute('data-set');
        createSession();
        errorMsg = findChildElementUsingIDAndClass('claim-msg-fail', 'className', errorContainer,[]);
    }

    if (/complete|interactive|loaded/.test(document.readyState)) {
        loadDefaultValues();
    } else {
        window.addEventListener("load", loadDefaultValues);
    }

    function createSession() {
        const country_code =  mainClaimSection.querySelector("#Country_code").getAttribute("data-set");
        const language_code =  mainClaimSection.querySelector("#Language_code").getAttribute("data-set");  
        const createSessionCatalogConfig = triggerCreateSession(country_code,language_code,current_hostname);
        openClose(claimSpinner, 'remove', 'd-none');
        httpRequest.post(createSessionCatalogConfig.createSessionurl,createSessionCatalogConfig.reqPayload,header)        
        .then((response) => {
            if(!response?.error) {
                sessionValue = response;
                show_captcha_feature === 'Y' ? createCaptchaAPI(response, current_hostname) :  openClose(claimSpinner, 'add', 'd-none');
            } else {
                showCommonErrorMessageWithCloseSpinner();
                setCookieOnCreateSessionResponse(response);
            }      
        }).catch(error => {
            showCommonErrorMessageWithCloseSpinner();             
        });
    }

        function showCommonErrorMessageWithCloseSpinner() { 
        openClose(errorMsg, 'remove', 'd-none');      
        openClose(claimSpinner, 'add', 'd-none');
    }

    function findChildElementUsingIDAndClass(name, type, mainContainer, arr) {
        if (mainContainer) {
            const match = mainContainer[type].includes(name);
            if (match) {
                arr.push(mainContainer)
            } else {
                if (mainContainer?.children && mainContainer.children.length > 1) {
                    const ad = Array.from(mainContainer.children);
                    ad.forEach((elem) => {
                        findChildElementUsingIDAndClass(name, type, elem, arr);
                    })
                } else if (mainContainer?.children && mainContainer.children.length == 1) {
                    findChildElementUsingIDAndClass(name, type, mainContainer.children[0], arr);
                }
            }
        }
        return arr[0];
    }

    function createCaptchaAPI(response, host) {
        const createReqObj = { response, host, header, successCallBack, errorCallBack };
        triggerGetCaptcha(createReqObj);
    }

    function successCallBack(res, captchaTree) {
        catchaResponse = res;
        const imgString =  res?.captcha?.image;
        const captchaImgElemnt = findChildElementUsingIDAndClass('captcha_img', 'id', captchaMainContainer.children[0], []);
        captchaImgElemnt.setAttribute('src', `data:image/png;base64,${imgString}`);
        openClose(claimSpinner, 'add', 'd-none');
        openClose(captchaMainContainer, 'remove', 'd-none');
    }

    function errorCallBack(err, captchaTree) {
        const APIClaimMessage = findChildElementUsingIDAndClass('api-failed-message', 'className', errorContainer, []);
        openClose(claimSpinner, 'add', 'd-none');
        openClose(APIClaimMessage, 'remove', 'd-none');
        APIClaimMessage.children[0].children[0].innerHTML =  err && err.error && err.error.message ? err.error.message : (err ? err : '');
    }

     function openClose(cls, type, clsnm) {
        cls?.classList && cls.classList[type](clsnm);
     }

    function refreshCaptcha() {
        openClose(errorMsg, 'add', 'd-none');
        if (sessionValue?.security?.session?.id && current_hostname && sessionValue?.security?.client_ip) {
            openClose(claimSpinner, 'remove', 'd-none');            
            createCaptchaAPI(sessionValue, current_hostname);
        } else {
            createSession();
        }
    }

    function listenCaptcha() {
        const errorMsg = findChildElementUsingIDAndClass('claim-msg-fail', 'className', errorContainer, []);
        openClose(errorMsg, 'add', 'd-none');
        try {
        const getSoundBase64 = `data:audio/wav;base64,${catchaResponse.captcha.sound}`;
        const audio = new Audio(getSoundBase64);
        audio.load();
        audio.play();
        } catch(error) {
            openClose(errorMsg, 'remove', 'd-none');
        }
    }
    
   function validateNumericInput(event, type) {
    if(type!="decimal"){
        isNaN(Number(event.data)) ? event.target.value = event.target.value.replace(event.data, "") : validateService(event, type);
    }
    else{       
        isNaN(Number(event.data)) ? event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1') : validateService(event, type);
    }
}

    // Show Free Text when Other is Selected
    function promptDetails(event) {
        const element = event.target;
        if (element && element.value) {
            element.parentElement.classList.remove('wu-input__error');
            const optionId = element[element.selectedIndex].id.split('.');
            let detailsFieldName = '';
            if(element.name.split('.')[0] === 'agerestriction'){detailsFieldName = "agerestriction.parentfullname"
                optionId.includes('No') ? toggleField('name', detailsFieldName, false, true) : toggleField('name', detailsFieldName);
            }
            else if(element.name.split('.')[0] === 'typeofservice'){detailsFieldName = "operationmtcnnumber"
                optionId.includes('moneytransfer') ? toggleField('name', detailsFieldName, false, false) : toggleField('name', detailsFieldName);
            }
            else if(element?.name.split('.')[0] === 'documenttype'){
                detailsFieldName = "documentnumber"
                if(optionId.includes('id') || optionId.includes('IdentityCard') || optionId.includes('alien') || optionId.includes('Ptp/Cpp')){
                    setMaxLengthandType((optionId.includes('id') || optionId.includes('IdentityCard')) ? 8 : 12 ,'number',detailsFieldName);
                }               
                else if(optionId.includes('Passport') || optionId.includes('Ruc')){
                    setMaxLengthandType(optionId.includes('Ruc') ? 11 : 12,'alphanumeric',detailsFieldName);
                }                
            }
        } else {
            element.parentElement.classList.add('wu-input__error');
        }
    }

    function setMaxLengthandType(maxlength,Datatype,DataField){
        let field = document.querySelector(`[name="${DataField}"]`);
        if (field) {
            field.value = ""
            field.setAttribute('maxLength',maxlength);
            field.dataset.type=Datatype;
        }
    }

    function validateUserInput(event) {
        if(event.target.dataset.type==="number") {
            isNaN(Number(event.data)) ? event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1') : validateService(event, event.target.dataset.type);
        }
        else {
             validateService(event, event.target.dataset.type)
        }
    }

    // Form Submit Function 
    function claimFormSubmit(e) {
        e.preventDefault();
        openClose(errorMsg, 'add', 'd-none');
        let CaptchaVal = true;
        if (show_captcha_feature === 'Y') {
            const CaptchaValSelector =  captchaMainContainer.querySelector("#captcha_input_bx");
            CaptchaVal = CaptchaValSelector && CaptchaValSelector.value;
        }
        
        if (validateAll('claimform') && CaptchaVal && disclaimerCheck.checked) {
            let formDataObject = { "claimform": {
                "name": {
                    "fullname": '',
                    "parentfullname":'',
                    "paternalname":'',
                    "maternalname":'',
                    "email":'',
                    "agerestriction": '',
                    "department": ''
                   },
                "address": {
                    "address": '',
                    "district": '',
                    "province": "huy",
                    },
                "mobile": {
                        "cellphone": '',
                        "telephone": '',
                     },
                "claimreason": {
                           "claimnumber": '',
                            "claimresponse":'',
                            "reason": '',
                            "applicationdetail": ''
                         },
                "claimdocument": {
                            "documenttype":'',
                            "documentnumber":'',
                            "filename":'',
                            "serviceType":'',
                            "order": '',
                            "dateofregistry":'',
                            "mtcn": ''
                          },
                "amount": {
                          "currency": '',
                          "claimamount":''
                          },
                "attachment":attachmentData.filename
            },
            "security": {
            "session": {
                "id": ""
            },
            "captcha": {
                "answer": ""
            }}};

            const personalInformation = mainClaimSection.querySelector('#form-section-ClaimantInformation');
            if (personalInformation) {
                let personalInfoFormControls = personalInformation.querySelectorAll('input:not([type="file"]), select');
                if (personalInfoFormControls && personalInfoFormControls.length) {
                    personalInfoFormControls.forEach(formField => {
                        if (formField) {
                            let value = formField.value.trim();
                            if (formField.id.includes('fullname')) formDataObject.claimform.name.fullname = value;                            
                            else if (formField.id.includes('paternalname')) formDataObject.claimform.name.paternalname = value;
                            else if (formField.id.includes('maternalname')) formDataObject.claimform.name.maternalname = value;
                            else if (formField.id.includes('email')) formDataObject.claimform.name.email = value;
                            else if (formField.id.includes('agerestriction')) formDataObject.claimform.name.agerestriction = value;
                            else if (formField.id.includes('department')) formDataObject.claimform.name.department = value;
                            else if (formField.id.includes('address')) formDataObject.claimform.address.address = value;
                            else if (formField.id.includes('district')) formDataObject.claimform.address.district = value;
                            else if (formField.id.includes('province')) formDataObject.claimform.address.province = value;
                            else if (formField.id.includes('documenttype')) formDataObject.claimform.claimdocument.documenttype = value;
                            else if (formField.id.includes('documentnumber')) formDataObject.claimform.claimdocument.documentnumber = value;
                            else if (formField.id.includes('claimresponse')) formDataObject.claimform.claimreason.claimresponse = value;
                            else if (formField.id.includes('cellphone')) formDataObject.claimform.mobile.cellphone = value;
                            else if (formField.id.includes('telephone')) formDataObject.claimform.mobile.telephone = value;                            
                            if (formField.id.includes('parentfullname')) {formDataObject.claimform.name.parentfullname = value};
                        }
                    })
                }
            }

            const IdentificationInfo = mainClaimSection.querySelector('#form-section-Identification');
            if (IdentificationInfo) {
                let identificationInfoFormControls = IdentificationInfo.querySelectorAll('input:not([type="file"]), select');
                if (identificationInfoFormControls && identificationInfoFormControls.length) {
                    identificationInfoFormControls.forEach(formField => {
                        if (formField) {
                            let value = formField.value.trim();
                            if (formField.id.includes('typeofservice')) formDataObject.claimform.claimdocument.serviceType = value;
                            else if (formField.id.includes('currency')) formDataObject.claimform.amount.currency = value;
                            else if (formField.id.includes('claimamount')) formDataObject.claimform.amount.claimamount = value; 
                            else if (formField.id.includes('operationmtcnnumber')) formDataObject.claimform.claimdocument.mtcn = value;                          
                        }
                    })
                }
            }

            const RequestDetail = mainClaimSection.querySelector('#form-section-RequestDetail');
            if (RequestDetail) {
                let RequestDetailFormControls = RequestDetail.querySelectorAll('input:not([type="file"]), select, textarea');
                if (RequestDetailFormControls && RequestDetailFormControls.length) {
                    RequestDetailFormControls.forEach(formField => {
                        if (formField) {
                            let value = formField.value.trim();
                            if (formField.id.includes('reason')) formDataObject.claimform.claimreason.reason = value;
                            else if (formField.id.includes('applicationdetail')) formDataObject.claimform.claimreason.applicationdetail = value;
                            else if (formField.id.includes('order')) formDataObject.claimform.claimdocument.order = value;
                            
                        }
                    })
                }
            }            
            formDataObject.claimform.claimdocument.dateofregistry = getCurrentDatetime();
            formDataObject.security.session.id = sessionValue?.security?.session?.id;
            if (show_captcha_feature === 'Y') {
                formDataObject.security.captcha.answer = captchaMainContainer.querySelector('#captcha_input_bx').value;
            }         
            getAPIResponse(formDataObject);
        } else {
            !CaptchaVal ? displayCaptchaAlert() : '';
            displayDisclaimerCheckAlert();
        }
    };

    function displayCaptchaAlert(response) {
        const mainFields = captchaMainContainer.children[1];
        const formField = findChildElementUsingIDAndClass('captcha_input_bx', 'id', mainFields, []);
        const errorMessage = findChildElementUsingIDAndClass("wrong_captcha_error", 'id', mainFields, []);
        const ApiErrorMessage = findChildElementUsingIDAndClass('wrong_captcha_api_error', 'id', mainFields, []);
        formField?.value?.trim() && formField?.validity?.valid && matchPattern(formField.value, 'captcha') && !response?.error?.message ? (formField?.parentElement?.classList.remove('wu-input__error'),errorMessage.classList.add('d-none')) : (formField?.parentElement?.classList.add('wu-input__error'),errorMessage.classList.remove('d-none'));
        response?.error?.message ? (ApiErrorMessage.innerHTML = response.error.message,errorMessage.classList.add('d-none'),formField.value='') : ApiErrorMessage.innerHTML = '';
    }

    function displayDisclaimerCheckAlert() {
        var mainFields = disclaimerCheckContainer.children[0];
        var formField = findChildElementUsingIDAndClass('disclaimer_check', 'id', mainFields, []);
        var disclaimerClass = findChildElementUsingIDAndClass('container-mar', 'className', mainFields, []);
        if(formField?.checked) {
            formField?.parentElement?.parentElement?.classList.remove('wu-input__error');
            disclaimerClass?.classList.remove('wu-input--error');
            formField.removeAttribute('style', 'outline: 2px solid #8c1c27');
        } else {
            formField?.parentElement?.parentElement?.classList.add('wu-input__error');
            disclaimerClass?.classList.add('wu-input--error');
            formField.setAttribute('style', 'outline: 2px solid #8c1c27');
        }
    }

    disclaimerCheck.addEventListener('change', (e) => {
        var mainFields = disclaimerCheckContainer.children[0];
        var formField = findChildElementUsingIDAndClass('disclaimer_check', 'id', mainFields, []);
        var disclaimerClass = findChildElementUsingIDAndClass('container-mar', 'className', mainFields, []);
        if(formField?.checked) {
            formField?.parentElement?.parentElement?.classList.remove('wu-input__error');
            disclaimerClass?.classList.remove('wu-input--error');
            formField.removeAttribute('style', 'outline: 2px solid #8c1c27');
        } else {
            formField?.parentElement?.parentElement?.classList.add('wu-input__error');
            disclaimerClass?.classList.add('wu-input--error');
            formField.setAttribute('style', 'outline: 2px solid #8c1c27');
        }
    });

    function getAPIResponse(formDataObject) {
        const successmsg = findChildElementUsingIDAndClass('claim-msg-success', 'className', errorContainer,[]);
		const submitEventLog = document.getElementById('button-submit-claimForm');
        openClose(claimSpinner, 'remove', 'd-none');
        openClose(errorMsg, 'add', 'd-none');
        const submiturl = `https://${current_hostname}/wudgtsrvs/mobiliser/rest/channel/GwpSubmitClaimForm`;
        httpRequest.post(submiturl, formDataObject, header)
            .then((response) => {
                openClose(claimSpinner, 'add', 'd-none');
                if (response.error) {
                    response?.error?.code ? mappedErrorCode(response) : openClose(errorMsg, 'remove', 'd-none');
                } else {
					submitEventLog && submitEventLog.click();
					claim_form_exists ? (clearFormData(claim_form_exists)) : '';
                    openClose(successmsg, 'remove', 'd-none');
                }
            }).catch(error => {
                showCommonErrorMessageWithCloseSpinner();               
            });
    }

    function clearFormData(formContents) {
        formContents.reset();
        attachmentData = {};
        if(show_captcha_feature === 'Y') {
            refreshCaptcha()
        }
    }

    function mappedErrorCode(response) {
        const errorCode = ['C5127','C9999'];
        if (errorCode.indexOf(response.error.code) > -1) {
           if (response.error.code==="C5127") {
            displayCaptchaAlert(response);
            createCaptchaAPI(response, current_hostname);
           }
           else {
            showGenericMessage();
            createSession();
           }
        }
    }
    
    function showGenericMessage(){        
        openClose(errorMsg, 'remove', 'd-none');
    }
    
    document.addEventListener('click', (e) => {
	if (e.target.className.indexOf("editBtn_FW") == -1) {		
		let editLabelFW =  mainClaimSection.querySelectorAll('.editLabel_FW');
		editLabelFW.forEach(className => {
		className.classList.add("d-none");
		});
		changeClass();
	} 
});

function changeClass(){
    let visi = mainClaimSection.querySelectorAll(".setOverflowVisCont");
	visi.forEach(className => {
		className.style.overflow = "hidden";
	});
}
}